import "@hotwired/turbo-rails"
import { Application } from "@hotwired/stimulus"

const application = Application.start()
application.debug = false

import SidebarController from "./controllers/sidebar_controller"
import DropdownController from "./controllers/dropdown_controller"
import ThemeToggleController from "./controllers/theme_toggle_controller"
import InboxController from "./controllers/inbox_controller"
import ConnectionStatusController from "./controllers/connection_status_controller"
import SubmenuController from "./controllers/submenu_controller"
import StackedBarChartController from "./controllers/stacked_bar_chart_controller"
import DonutChartController from "./controllers/donut_chart_controller"
import LiquidEditorController from "./lib/liquid_editor_controller"
import SortableAttributesController from "./controllers/sortable_attributes_controller"
import CrmBoardController from "./controllers/crm_board_controller"
import SegmentPreviewController from "./controllers/segment_preview_controller"
import SegmentFormController from "./controllers/segment_form_controller"
import PipelineCanvasController from "./controllers/pipeline_canvas_controller"
import PipelineCanvasHostController from "./controllers/pipeline_canvas_host_controller"
import CsvImporterController from "./controllers/csv_importer_controller"
import { controllerDefinitions as refineControllers } from "@clickfunnels/refine-stimulus"

application.register("sidebar", SidebarController)
application.register("dropdown", DropdownController)
application.register("theme-toggle", ThemeToggleController)
application.register("inbox", InboxController)
application.register("connection-status", ConnectionStatusController)
application.register("submenu", SubmenuController)
application.register("stacked-bar-chart", StackedBarChartController)
application.register("donut-chart", DonutChartController)
application.register("liquid-editor", LiquidEditorController)
application.register("sortable-attributes", SortableAttributesController)
application.register("crm-board", CrmBoardController)
application.register("segment-preview", SegmentPreviewController)
application.register("segment-form", SegmentFormController)
application.register("pipeline-canvas", PipelineCanvasController)
application.register("pipeline-canvas-host", PipelineCanvasHostController)
application.register("csv-importer", CsvImporterController)
application.load(refineControllers)
